"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const backwardCompatibilityForProperties_1 = require("../../helpers/backwardCompatibilityForProperties");
const LoaderConstants_1 = require("./LoaderConstants");
const test_utils_1 = require("../../utils/test-utils");
const Loader_module_scss_1 = __importDefault(require("./Loader.module.scss"));
const Loader = (0, react_1.forwardRef)(({ svgClassName, className, size, color, hasBackground = false, id, "data-testid": dataTestId }, ref) => {
    const overrideClassName = (0, backwardCompatibilityForProperties_1.backwardCompatibilityForProperties)([className, svgClassName], "");
    const sizeStyle = (0, react_1.useMemo)(() => {
        if (typeof size === "number") {
            return { width: size, height: size };
        }
        return undefined;
    }, [size]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)("monday-loader-component", Loader_module_scss_1.default.loaderContainer), ref: ref, role: "alert", title: "loading", style: sizeStyle, id: id, "data-testid": dataTestId || (0, test_utils_1.getTestId)(test_utils_1.ELEMENT_TYPES.LOADER, id) }, { children: (0, jsx_runtime_1.jsxs)("svg", Object.assign({ className: (0, classnames_1.default)("circle-loader-spinner", Loader_module_scss_1.default.circleLoaderSpinner, overrideClassName), viewBox: "0 0 50 50", color: color, "aria-hidden": true }, { children: [hasBackground && ((0, jsx_runtime_1.jsx)("circle", { className: Loader_module_scss_1.default.circleLoaderSpinnerBackground, cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" })), (0, jsx_runtime_1.jsx)("circle", { className: (0, classnames_1.default)("circle-loader-spinner-path", Loader_module_scss_1.default.circleLoaderSpinnerPath), cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" })] })) })));
});
Object.assign(Loader, {
    sizes: LoaderConstants_1.LoaderSizes,
    colors: LoaderConstants_1.LoaderColors
});
exports.default = Loader;
